
import { Component} from '@angular/core';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { RootService } from 'src/app/shared/services/root.service';
import { environment } from '../../../environments/environment';
import { SeoService } from 'src/app/shared/seo/seo.service';

declare var $;
@Component({
  selector: 'app-find-dealers',
  templateUrl: './find-dealers.component.html',
  styleUrls: ['./find-dealers.component.scss']
})
export class FindDealersComponent {
  sub: Subscription = new Subscription();
  dealerLocaterForm!: FormGroup;
  stateList: any;
  environment1 =environment.s3bucket.url;
  districtList: any;
  maker: boolean = true;
  divisions: any = [];
  dataloaded: boolean = false;
  latLongList: any[] = [];
  previous: any;
  centerLat = 23.473324;
  centerLng = 77.947998;
  countryRestriction = {
    latLngBounds: {
      east: 97.4025614766,
      north: 35.4940095078,
      south: 7.96553477623,
      west: 68.1766451354,
    },
    strictBounds: true,
  };
  Lng: any;
  Lat: any;
  zoom = 4;
  breadcrumbData: any = [];
  countDisplay: any = 0;
  flag: boolean = false;
  clickDisable: boolean = false;
  openedWindow: any;
  division: any;
  openAgmWindow: boolean = false;
  isUserLoggedIn: boolean;
  userData:any;
  matchDistrict : boolean;
  dealerCode: string;

  metatitle: any = "Find Tata Motors Dealer | Nearest Dealer Outlet Locator";
  metadesc: any="Enquire, book and buy online Tata Ace, Intra, Yodha Pickup, Winger, Magic, Signa, Prima, Ultra, and entire Truck, Tipper, Bus range with Tata Motors authorized dealers.";


  constructor(private apiService: ApiService,  private router: Router,private seoservice: SeoService,
    private formBuilder: FormBuilder, private route: ActivatedRoute,
    private rootService: RootService, private behaviorService: BehaviourSubjectService ) { }

  ngOnInit(): void {
    this.seo();
    this.dealerCode= localStorage.getItem("dealercd");
    this.sub.add(this.behaviorService.isLoggedIn.subscribe(() => {
      this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
      this.userData = this.rootService.getUserData();
    }));
    $('.header').addClass('p-scroll');
    this.route?.url.subscribe(([url]) => {
      if (url?.path == "find-dealers") {
        this.breadcrumbData = ["find-dealers"]
      } else {
        this.breadcrumbData = []
      }
    });
    this.dealerLocaterForm = this.formBuilder.group({
      lob: ["", Validators.required],
      state: ["", Validators.required],
      district: ["", Validators.required],
    });
    this.getStateList();
  }
  seo() {
    this.seoservice.updateTitle(this.metatitle);
    this.seoservice.updateMetaTag("description", null, this.metadesc);
    this.seoservice.updateMetaTag(null, "og:locale", "en_US");
    this.seoservice.updateMetaTag(null, "og:type", "Website");
    this.seoservice.updateMetaTag(
      null,
      "og:title",
      this.metatitle
    );
    this.seoservice.updateMetaTag(null, "og:description", this.metadesc);
    this.seoservice.updateMetaTag(null, "og:url", environment.baseUrl + this.router.url);
    this.seoservice.updateMetaTag(null, "og:site_name", "Tata OSP");
  }

  // initial center position for the map
  lat: number = 51.673858;
  lng: number = 7.815982;
  close() {
    this.maker = true;
    this.openAgmWindow = false;
  }

  isInfoWindowOpen(id: any) {
    return this.openedWindow == id; // alternative: check if id is in array
  }
  clickedMarker(infowindow: any) {
    if (this.previous) {
      this.previous.close();
    }
    this.previous = infowindow;
  }


  markers: marker[] = [
    {
      lat: 51.673858,
      lng: 7.815982,
      label: "A",
      draggable: true,
      content: "InfoWindow content",
      color: "#FFFFFF",
      iconUrl: "http://maps.google.com/mapfiles/ms/micons/gas.png"
    },
    {
      lat: 51.373858,
      lng: 7.215982,
      label: "B",
      draggable: false,
      content: "InfoWindow content",
      color: "blue",
      iconUrl: "http://maps.google.com/mapfiles/ms/micons/dollar.png"
    },
    {
      lat: 51.723858,
      lng: 7.495982,
      label: "C",
      draggable: true,
      content: "InfoWindow content",
      color: "red",
      iconUrl: "http://maps.google.com/mapfiles/ms/micons/police.png"
    }
  ];


  // just an interface for type safety.


  getStateList() {
    this.division = [];
    let data = {
      'action_type': "state",
      'dealer_code':this.dealerCode ?this.dealerCode:""

    };

    this.sub.add(this.apiService.findDealers(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.stateList = response["data"];
          if(this.dealerCode && this.stateList?.length > 0){
            this.dealerLocaterForm.patchValue({
              state: this.stateList[0].name+","+this.stateList[0].code,
            });
            this.getDistrict();
            return

          }
          if(!this.isUserLoggedIn){
            this.dealerLocaterForm.patchValue({
              state: "Maharashtra,MH",
            });
            this.getDistrict();
          }
          else if (this.isUserLoggedIn && (!this.userData?.state || !this.userData?.district)) {
            this.dealerLocaterForm.patchValue({
              state: "Maharashtra,MH",
            });
            this.getDistrict();
          }
          else if (this.isUserLoggedIn) {
            let statecode;
            this.stateList?.forEach((e: any) => {
              if (e.name?.toLowerCase() == this.userData.state?.toLowerCase()) {
                statecode = e.code;
              }
            });
            if (!statecode) {
              this.dealerLocaterForm.patchValue({
                state: "Maharashtra,MH",
              });
            }
            else {


        let state = this.userData.state + ',' + statecode;
        this.dealerLocaterForm.patchValue({
          state: state,
        });
      }

        this.getDistrict();
          }
        }
        else {
          this.stateList = [];
          if(this.dealerCode){
            this.dealerCode="";
            this.getStateList();
          }
        }
      },
      error: () => {
        this.stateList = [];

      },
      complete: () => {
      }
    })
    );
  }

  getDistrict(item?) {
    this.countDisplay = 0;
    this.flag = true;
    this.centerLat = 23.473324;
    this.centerLng = 77.947998;
    this.zoom = 4;
    this.maker = true;
    this.dataloaded = true;
    this.divisions = [];
    this.division = [];
    this.districtList = [];

    this.dealerLocaterForm.patchValue({
      district: "",
      lob: "",
    });
    let state = this.dealerLocaterForm.value?.state;
    let statedata = state.split(",");
    let ll = {};
    ll = {
      code: statedata[1],
      state: statedata[0],
    };
    let data = {
      'action_type': 'district',
      'state': ll,
      'dealer_code':this.dealerCode

    };

    this.sub.add(this.apiService.findDealers(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.districtList = response["data"];
          if(this.dealerCode && this.districtList?.length == 1){
            this.dealerLocaterForm.patchValue({
              district: this.districtList[0],
            });
            this.findDealerData();

            return
          }
          if(this.dealerCode && this.districtList?.length > 1){
            this.dealerLocaterForm.patchValue({
              district: "",
            });
            return
          }
          if(!this.isUserLoggedIn && !item){
          this.dealerLocaterForm.patchValue({
            district: "mumbai suburban",
          });
          this.findDealerData();

          } else if (this.isUserLoggedIn && (!this.userData?.state || !this.userData.district) && !item) {
            this.dealerLocaterForm.patchValue({
              district: "mumbai suburban",
            });
            this.findDealerData();
          }
          else if (this.isUserLoggedIn && !item) {
            this.districtList.forEach((e: any) => {
              if (e?.toLowerCase() == this.userData?.district?.toLowerCase()) {
                this.matchDistrict = true;
              }
            });
            if (this.matchDistrict) {
              this.dealerLocaterForm.patchValue({
                district: this.userData?.district,
              });
              this.findDealerData();

            }
            else {
              this.dealerLocaterForm.patchValue({
                state: "Maharashtra,MH",
              });
              this.checkStateDistrict();

            }
            if (item) {
              this.dealerLocaterForm.patchValue({
                district: "",
              });
              this.findDealerData();

            }
          }
        }
        else {
          this.districtList = [];
        }


      },
      error: () => {
        this.districtList = [];

      },
      complete: () => {

      }
    })
    );

  }

  checkStateDistrict() {
    let ll = {
      code: "MH",
      state: "Maharashtra",
    };
    let data = {
      'action_type': 'district',
      'state': ll,
    };

    this.sub.add(this.apiService.findDealers(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.districtList = response["data"];
          this.dealerLocaterForm.patchValue({
            district: "mumbai suburban",
          });

          this.findDealerData();
        }
        else {
          this.districtList = [];
        }
      },
      error: () => {
        this.districtList = [];

      },
      complete: () => {
      }
    })
    );
  }
  findDealerData() {
    this.countDisplay = 0;
    this.divisions = [];
    let state = this.dealerLocaterForm.value.state;
    let statedata = state.split(",");

    let data = {
      state: {
        "code": statedata[1],
        "state": statedata[0]
      },
      "offset": 0,
      "size": 100,
      "district": this.dealerLocaterForm.value.district,
      'dealer_code':this.dealerCode ? this.dealerCode : ""

    };


    this.sub.add(this.apiService.findDealers(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.division = response["data"];
          this.division.forEach((e: any) => {
            e.country_code = e.mobile_number.slice(0, 2)
            e.mobile_number_new = e.mobile_number.slice(2,)
          })
          this.dataloaded = true;
          this.flag = false;

          this.Lat = response["data"][0].latitude;
          this.Lng = response["data"][0].longitude;
          this.centerLat = Number(this.Lat);
          this.centerLng = Number(this.Lng);
          this.zoom = 8;
          this.maker = true;
          response["data"].forEach((res: any) => {
            this.divisions.push(res);
            this.divisions.forEach((e: any) => {
              e.country_code = e.mobile_number.slice(0, 2)
              e.mobile_number_new = e.mobile_number.slice(2,)
            })
            if (res.latitude && res.longitude) {
              this.latLongList.push({ lat: res.latitude, long: res.longitude });
            }
          });
          this.countDisplay = this.divisions?.length;
          this.clickDisable = false;
        } else {
          this.flag = true;
          this.centerLat = 23.473324;
          this.centerLng = 77.947998;
          this.zoom = 4;
          this.maker = true;
          this.dataloaded = true;
        }
      },
      error: () => {

      },
      complete: () => {
      }
    })
    );
  }

  public mapReady(map: any) {
    map.addListener("dragend", () => {
    });
  }
  getDirection(id: any, lat: any, lng: any) {
    this.maker = false;
    this.Lat = this.divisions[0].latitude;
    this.Lng = this.divisions[0].longitude;
    this.centerLat = Number(this.Lat);
    this.centerLng = Number(this.Lng);
    this.setDirection(id, lat, lng);
  }

  setDirection(id: any, lat: any, lng: any) {
    this.centerLat = Number(lat);
    this.centerLng = Number(lng);
    this.maker = true;
    this.openWindow(id);
  }

  openWindow(id: any) {
    this.openedWindow = id;
    this.zoom = 14;
  }
  getNumber(number: any) {
    return 'tel:' + number
  }

}
interface marker {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
  content: string;
  color: string;
  iconUrl: string;
}
